export default __webpack_public_path__ + "static/superbetter-problem-solve-afaefd9eb93a30bd68646d11b1925269.webp";